// extracted by mini-css-extract-plugin
export default {"titleContainer":"OurO","inputContainer":"G3_Z"};